import React from 'react';
import { NotesTabNavigationParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import UseUserNotes from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import TransferNote from '../../../../shared/Notes/TransferNote';
import { noteFileToNotModified } from '../../../../shared/Notes/utils/noteFileToNoteModified';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

export type NoteTransferScreenOwnProps = {};

export type NoteTransferScreenProps = NoteTransferScreenOwnProps & {
    route: RouteProp<NotesTabNavigationParamList, 'transfer'>;
};

const NoteTransferScreen: React.FC<NoteTransferScreenProps> = (props) => {
    const goBack = useGoBack();
    const { note, isLoadingNote, updateUserNote, isUpdatingUserNote } = UseUserNotes({
        noteId: props.route.params.noteId,
        onUpdateSuccess: () => {
            goBack();
        },
    });

    return (
        <AnimateLoadedContent isLoading={!note || isLoadingNote}>
            {() => (
                <TransferNote
                    note={note!}
                    onTransfer={(destination) => {
                        updateUserNote({
                            drySubmit: false,
                            note: {
                                ...note!,
                                files: note!.files.map(noteFileToNotModified),
                                images: note!.images.map(noteFileToNotModified),
                                ...destination,
                            },
                            noteId: props.route.params.noteId,
                        });
                    }}
                    isTransferring={isUpdatingUserNote}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteTransferScreen);
